/*
 * The regex used here comes from redux-forms email validation
 * https://redux-form.com/6.6.3/examples/fieldlevelvalidation/
 */

exports.DEFAULT_DOES_CONTAIN_EMAIL_REGEX = /\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}\b/i;

exports.validateEmail = (email) => {
  const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
  return emailRegex.test(email);
};

function isValidRegex (pattern) {
  try {
    return !!new RegExp(pattern);
  } catch {
    return false;
  }
}

exports.doesContainEmail = (string, emailRegexString) => {
  if (emailRegexString && isValidRegex(emailRegexString)) {
    return new RegExp(emailRegexString).test(string);
  }
  return /\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}\b/i.test(string);
};
